const PRE = 'z'
export default {
  button: PRE + '-button',
  icon: PRE + '-icon',
  slider: PRE + '-slider',
  rate: PRE + '-rate',
  upload: 'fc-upload',
  cascader: PRE + '-cascader',
  popover: PRE + '-popover',
  tooltip: PRE + '-tooltip',
  colorPicker: PRE + '-colorPicker',
  timePicker: PRE + '-time-picker',
  timeSelect: PRE + '-time-select',
  datePicker: PRE + '-date-picker',
  switch: PRE + '-switch',
  select: 'fc-select',
  checkbox: 'fc-checkbox',
  radio: 'fc-radio',
  inputNumber: PRE + '-input-number',
  number: PRE + '-input-number',
  input: PRE + '-input',
  textarea: PRE + '-input',
  formItem: PRE + '-form-item',
  form: PRE + '-form',
  frame: 'fc-frame',
  col: PRE + '-col',
  row: PRE + '-row',
  tree: 'fc-tree',
  inputTag: PRE + '-input-tag',
  inputOtp: PRE + '-input-otp',
  mention: PRE + '-mention',
  transfer: PRE + '-transfer',
  treeSelect: PRE + '-tree-select',
  autoComplete: PRE + '-autocomplete',
  auto: PRE + '-autocomplete',
  group: 'fc-group',
  array: 'fc-group',
  object: 'fc-sub-form',
  subForm: 'fc-sub-form',
  elAlert: PRE + '-alert',
  elButton: PRE + '-button',
  elCard: PRE + '-card',
  elCollapse: PRE + '-collapse',
  elCollapseItem: PRE + '-collapse-item',
  elDivider: PRE + '-divider',
  elImage: PRE + '-image',
  elTag: PRE + '-tag',
  elTabs: PRE + '-tabs',
  elTabPane: PRE + '-tab-pane',
  elTransfer: PRE + '-transfer',
  elTreeSelect: PRE + '-tree-select',
  space: PRE + '-space',
}
